import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createTextVNode as _createTextVNode, unref as _unref, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, isRef as _isRef, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "d-flex align-items-center" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", { style: {"width":"7rem"} }, "Tìm kiếm", -1)

import { debounce } from 'lodash';
import { onMounted, ref, watch } from 'vue';
import { setCurrentPageTitle } from '@/core/helpers/breadcrumb';
import { useButtonCustom } from '@/core/hooks/use-button-custom';
import { useRouterCustom } from '@/core/hooks/use-router-custom';
import { usePagination } from '@/core/hooks/use-pagination';
import { BienBanGiaiTheService } from '@/core/services/BienBanGiaiThe.service';
import { useLoading } from '@/core/hooks/use-loading';
import { swalErrNotification } from '@/core/helpers/utils';
import { IBienBanGiaiTheResponseBase } from '@/core/interfaces/ApiResponses';

import BienBanGiaiTheTable from '@/components/shared/bien-ban-giai-the-table/BienBanGiaiTheTable.vue';
import ButtonCustom from '@/components/shared/buttons/ButtonCustom.vue';
import PageRowLayout from '@/layout/_shared/PageRowLayout.vue';
import Pagination from '@/components/shared/pagination/Pagination.vue';
import PerPageSelection from '@/components/shared/per-page-selection/PerPageSelection.vue';
import ConfirmHoanThanh
  from "@/views/crafted/pages/bien-ban-giai-the/confirm-hoan-thanh-bien-ban-modal/ConfirmHoanThanh.vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'Index',
  setup(__props) {

const { ButtonsType } = useButtonCustom();
const { push } = useRouterCustom();
const { startLoading, endLoading } = useLoading();
const { currentPage, totalItems, perPage, perPageArr, searchTerm } = usePagination();

const items = ref<IBienBanGiaiTheResponseBase[]>([]);

onMounted(async () => {
  setCurrentPageTitle('Biên bản giải thể');

  await fetchBienBanGiaiTheItems();
});

watch(
  () => currentPage.value,

  () => {
    fetchBienBanGiaiTheItems();
  }
)

watch(
  () => perPage.value,

  () => {
    fetchBienBanGiaiTheItems();
  }
)

const fetchBienBanGiaiTheItems = async () => {
  startLoading();

  try {
    const {
      data: {
        data: {
          data: res,
          total,
        },
      },
    } = await BienBanGiaiTheService.list({
      current_page: currentPage.value,
      per_page: perPage.value,
      searchTerm: searchTerm.value,
    });

    totalItems.value = total;

    items.value = res;

    endLoading();
  } catch(e) {
    endLoading();
    swalErrNotification(
      e,
      'Có lỗi xảy ra khi lấy thông tin biên bản',
    );
  }
}

const searchForBBGT = debounce(() => {
  fetchBienBanGiaiTheItems();
}, 700);

const selectingBienBan = ref<IBienBanGiaiTheResponseBase | null>(null);

const confirmHoanThanhBienBan = ref(false);

const onHoanThanhHandler = ({ id: bienBanGiaiTheId }: { id: number }) => {
  const foundBienBan = items.value.find(({ id: idBienBan }) => bienBanGiaiTheId === idBienBan);

  if (foundBienBan) {
    selectingBienBan.value = foundBienBan;

    confirmHoanThanhBienBan.value = true;
  }
}

const hoanThanhHander = async () => {
  confirmHoanThanhBienBan.value = false;

  await fetchBienBanGiaiTheItems();
}

return (_ctx: any,_cache: any) => {
  const _component_el_input = _resolveComponent("el-input")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(ConfirmHoanThanh, {
      "bien-ban-data": selectingBienBan.value,
      show: confirmHoanThanhBienBan.value,
      onConfirm: hoanThanhHander,
      onClose: _cache[0] || (_cache[0] = ($event: any) => (confirmHoanThanhBienBan.value = false))
    }, null, 8, ["bien-ban-data", "show"]),
    _createVNode(PageRowLayout, null, {
      "page-row-header": _withCtx(() => [
        _createTextVNode(" Danh sách ")
      ]),
      "page-row-action-button": _withCtx(() => [
        _createVNode(ButtonCustom, {
          "button-type": _unref(ButtonsType).ADD,
          onClick: _cache[1] || (_cache[1] = ($event: any) => (_unref(push)('/quan-ly/bien-ban-giai-the/tao-moi')))
        }, null, 8, ["button-type"])
      ]),
      "page-row-content": _withCtx(() => [
        _createVNode(PerPageSelection, {
          "per-page": _unref(perPage),
          "per-page-arr": _unref(perPageArr),
          onChange: _cache[3] || (_cache[3] = (value) => perPage.value = value)
        }, {
          other: _withCtx(() => [
            _createElementVNode("div", _hoisted_1, [
              _hoisted_2,
              _createVNode(_component_el_input, {
                modelValue: _unref(searchTerm),
                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (_isRef(searchTerm) ? (searchTerm).value = $event : null)),
                style: {"width":"20rem"},
                placeholder: "tìm theo mã hoặc tên",
                onInput: _unref(searchForBBGT)
              }, null, 8, ["modelValue", "onInput"])
            ])
          ]),
          _: 1
        }, 8, ["per-page", "per-page-arr"]),
        _createVNode(BienBanGiaiTheTable, {
          "is-ke-hoach-column-displaying": true,
          items: items.value,
          "is-hoan-thanh-button-displayed": true,
          onOnDetailClick: _cache[4] || (_cache[4] = ({ id }) => _unref(push)(`/quan-ly/bien-ban-giai-the/chi-tiet/${id}`)),
          onOnEditClick: _cache[5] || (_cache[5] = ({ id }) => _unref(push)(`/quan-ly/bien-ban-giai-the/cap-nhat/${id}`)),
          onOnCheckClick: onHoanThanhHandler
        }, null, 8, ["items"]),
        (items.value.length > 0)
          ? (_openBlock(), _createBlock(Pagination, {
              key: 0,
              page: _unref(currentPage),
              "page-size": _unref(perPage),
              total: _unref(totalItems),
              onChangePage: _cache[6] || (_cache[6] = (value) => currentPage.value = value)
            }, null, 8, ["page", "page-size", "total"]))
          : _createCommentVNode("", true)
      ]),
      _: 1
    })
  ], 64))
}
}

})